import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import Swal from "sweetalert2";

// components

export default function CardEditProduct() {
  const [datas, setDatas] = useState("");
  const [category, setCategory] = useState("");
  const [unit, setUnit] = useState("");
  const [productGroup, setProductGroup] = useState("");
  const [exist, setExist] = useState("");
  const [checkPass, setCheckPass] = useState(false);
  const { productCode } = useParams();
  const [history, setHistory] = useState("");
  const { user } = useSelector(state => state.user)


  useEffect(() => {
    axios.post(`http://${process.env.REACT_APP_API_URL}/products/search-pagination`, { productCode: productCode }, {
      headers: {
        Bearer: localStorage.getItem('token')
      }
    }).then((response) => {
      if (response.status === 200) {
        delete response.data.password;
        setDatas(response.data?.productHis[0]?.product);
        setHistory(response.data?.productHis[0]?.history);
      }
    }
    ).catch((error) => {
      if (error.response.data.status === 401) {
        window.location.href = "/auth/login";
      }
      console.log(error);
    });

  }, [productCode])
  // useEffect(() => {
  //   axios.post(`http://${process.env.REACT_APP_API_URL}/products/search`, { productCode: productCode }, {
  //     headers: {
  //       Bearer: localStorage.getItem('token')
  //     }
  //   }).then((response) => {
  //     if (response.status === 200) {
  //       delete response.data.password;
  //       setDatas(response.data);
  //     }
  //   }
  //   ).catch((error) => {
  //     if (error.response.data.status === 401) {
  //       window.location.href = "/auth/login";
  //     }
  //     console.log(error);
  //   });

  // }, [productCode])

  useEffect(() => {
    axios.get(`http://${process.env.REACT_APP_API_URL}/utility/search-category`, {
      headers: {
        Bearer: localStorage.getItem('token')
      }
    }).then((response) => {
      if (response.status === 200) {
        setCategory(response.data);
      }
    }
    ).catch((error) => {
      if (error.response.data.status === 401) {
        window.location.href = "/auth/login";
      }
      console.log(error);
    });

    axios.get(`http://${process.env.REACT_APP_API_URL}/utility/search-unit`, {
      headers: {
        Bearer: localStorage.getItem('token')
      }
    }).then((response) => {
      if (response.status === 200) {
        setUnit(response.data);
      }
    }
    ).catch((error) => {
      if (error.response.data.status === 401) {
        window.location.href = "/auth/login";
      }
      console.log(error);
    });

    axios.get(`http://${process.env.REACT_APP_API_URL}/utility/search-product-group`, {
      headers: {
        Bearer: localStorage.getItem('token')
      }
    }).then((response) => {
      if (response.status === 200) {
        setProductGroup(response.data);
      }
    }
    ).catch((error) => {
      if (error.response.data.status === 401) {
        window.location.href = "/auth/login";
      }
      console.log(error);
    });

  }, [])

  const handleImg = (e) => {
    //tobase64
    const file = e.target.files[0];
    // check hieght and width
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        console.log(reader);
        const base64String = reader.result.split(',')[1];
        setDatas({ ...datas, image: base64String })
      };
      reader.onerror = () => {
        console.error('AHHHHHHHH!!');
      };
    } else {
      setDatas({ ...datas, image: "" })
    }

  }

  const handleData = (e) => {
    setDatas({ ...datas, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    if (datas.qty < datas.decreaseStock) {
      Swal.fire({
        icon: 'error',
        text: 'จำนวนสินค้าไม่พอ!',
        showConfirmButton: false,
        timer: 1500
      })
    } else {
      if (datas.increaseStock) {
        datas.qty = Number(datas.qty) + Number(datas.increaseStock);
      }
      if (datas.decreaseStock) {
        datas.qty = Number(datas.qty) - Number(datas.decreaseStock);
      }
      if (datas.qty === 0) {
        datas.qty = "0";
      }
     
      axios.post(`http://${process.env.REACT_APP_API_URL}/products/save`, datas, {
        headers: {
          Bearer: localStorage.getItem('token')
        }
      }).then((response) => {
        // console.log(response);
        if (response.status === 200) {
          Swal.fire({
            icon: 'success',
            text: 'Success!',
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            window.location.href = "/product";
          }
          )
        }
      }
      ).catch((error) => {
        if (error.response.data.status === 401) {
          window.location.href = "/auth/login";
        }
        console.log(error.response.data.message);
      });
    }
  };

  return (
    <>
      <div className="relative flex flex-col w-full min-w-0 p-5 mb-6 break-words bg-white rounded shadow-lg" style={{ borderRadius: "20px" }}>
        <div className="px-4 py-3 mb-0 border-0 rounded">
          <div className="flex flex-wrap items-center">
            <div className="relative flex-1 flex-grow w-full max-w-full mb-2">
              <h1 className="text-3xl font-bold semibold text-blueGray-700">
                Update Product
              </h1>
            </div>
          </div>
        </div>
        <div className="block w-full mb-1 overflow-x-auto ">
          {/* Projects table */}
          <form onSubmit={(e) => { handleSubmit(e) }}>
            <div className="grid mb-6 -mx-3">
              <div className="flex">
                <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                  <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                    รหัสสินค้า
                  </label>
                  <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                    id="productCode" name="productCode" type="text" onChange={handleData} value={datas.productCode} />
                  {!datas.productCode && <p className="text-xs italic text-red-500">โปรดกรอก รหัสสินค้า</p>}
                </div>
                <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                  <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                    ชื่อสินค้า
                  </label>
                  <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                    id="productName" name="productName" type="text" onChange={handleData} value={datas.productName} />
                  {!datas.productName && <p className="text-xs italic text-red-500">โปรดกรอก ชื่อสินค้า</p>}
                </div>
              </div>
              <div className="flex">
                <div className="px-3 mb-3 md:mb-0 " style={{ width: "300px" }}>
                  <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                    กลุ่มสินค้า
                  </label>
                  <select name="productGroup" id="productGroup" className="rounded" onChange={handleData} style={{ width: "275px", height: "50px" }} value={datas.productGroup}>
                    <option value="" disabled selected>Choose</option>
                    {
                      productGroup && productGroup.map((data, index) => {
                        return (
                          <option key={index} value={data.id}>{data.productGroupName}</option>
                        )
                      }
                      )
                    }
                  </select>
                  {!datas.productGroup && <p className="mt-3 text-xs italic text-red-500">โปรดเลือก กลุ่มสินค้า </p>}

                </div>
                <div className="px-3 mb-3 md:mb-0 " style={{ width: "300px" }}>
                  <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                    ประเภทสินค้า
                  </label>
                  <select name="category" id="category" className="rounded" onChange={handleData} style={{ width: "275px", height: "50px" }} value={datas.category} >
                    <option value="" disabled selected>Choose</option>
                    {
                      category && category.map((data, index) => {
                        return (
                          <option key={index} value={data.id}>{data.categoryName}</option>
                        )
                      }
                      )
                    }

                  </select>
                  {!datas.category && <p className="mt-3 text-xs italic text-red-500">โปรดเลือก ประเภทสินค้า </p>}
                </div>
              </div>
              <div className="flex">
                <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                  <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                    Model
                  </label>
                  <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                    id="model" name="model" type="text" onChange={handleData} value={datas.model} />
                  {/* <p className="text-xs italic text-red-500">Please fill out this field.</p> */}
                </div>

                <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                  <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                    หน่วยสินค้า
                  </label>
                  <select name="unit" id="unit" className="rounded" onChange={handleData} style={{ width: "275px", height: "50px" }} value={datas.unit}>
                    <option value="" disabled selected>Choose</option>
                    {
                      unit && unit.map((data, index) => {
                        return (
                          <option key={index} value={data.id}>{data.unitName}</option>
                        )
                      }
                      )
                    }
                  </select>
                  {!datas.unit && <p className="mt-3 text-xs italic text-red-500 ">โปรดเลือก  หน่วยสินค้า </p>}
                </div>
              </div>
              <div className="flex">
                <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                  <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                    จำนวนสินค้า
                  </label>
                  <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                    disabled id="qty" name="qty" type="number" value={datas.qty} />
                  {/* {!datas.qty && <p className="text-xs italic text-red-500">โปรดกรอก จำนวนสินค้า</p>} */}
                </div>
                <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                  <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                    ราคาทุน
                  </label>
                  <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                    id="cost" name="cost" type="number" onChange={handleData} value={datas.cost} />
                  {!datas.cost && <p className="text-xs italic text-red-500">โปรดกรอก ราคาทุน</p>}
                </div>
                <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                  <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                    เพิ่มจำนวนสินค้า
                  </label>
                  <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                    disabled={datas.decreaseStock} id="increaseStock" name="increaseStock" type="number" onChange={handleData} />
                </div>
              </div>
              <div className="flex">
                <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                  <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                    ราคาต่อหน่วย
                  </label>
                  <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                    id="pricePerUnit" name="pricePerUnit" type="number" onChange={handleData} value={datas.pricePerUnit} />
                  {!datas.pricePerUnit && <p className="text-xs italic text-red-500">โปรดกรอก ราคาต่อหน่วย</p>}
                </div>
                <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                  <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                    ส่วนลด
                  </label>
                  <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                    id="discount" name="discount" type="number" onChange={handleData} value={datas.discount} min={0} />
                  {/* {!datas.discount && <p className="text-xs italic text-red-500">โปรดกรอก ส่วนลด</p>} */}
                </div>
                <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                  <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                    ลดจำนวนสินค้า
                  </label>
                  <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                    disabled={datas.increaseStock} id="decreaseStock" name="decreaseStock" type="number" onChange={handleData} />
                </div>
              </div>
              <div className="flex">
                <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                  <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                    รูปภาพสินค้า
                  </label>
                  <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                    id="image" name="image" type="file" onChange={handleImg} />
                </div>
                {datas.image && <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                  <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                    Preview image
                  </label>
                  <img src={`data:image/jpeg;base64,${datas.image}`} style={{ width: "200px", height: "200px" }} />
                </div>}
              </div>
              {/* {!checkPass && !exist && */}
              {user.role == 99 && <div className="w-full px-3 mb-3 md:mb-0">
                <button
                  className={"px-3 py-3 m-1 mr-1 text-xs font-bold text-white uppercase transition-all duration-150 ease-linear bg-indigo-500 rounded outline-none active:bg-indigo-600 focus:outline-none"}
                  type="submit"
                  disabled={checkPass || exist}
                >
                  Update
                </button>
              </div>}
              {/* } */}
              <div className="mt-3 ">
                <label className="mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase " >History</label>
                <table className="text-center table-order-products">
                  <thead >
                    <tr>
                      <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">#</th>
                      <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">วันที่</th>
                      <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">อัพเดทโดย</th>
                      <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">รหัสสินค้า</th>
                      <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">ชื่อสินค้า</th>
                      <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">กลุ่มสินค้า</th>
                      <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">ประเภทสินค้า</th>
                      <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">Model</th>
                      <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">หน่วย</th>
                      <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">จำนวนสินค้า</th>
                      <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">ราคาทุน</th>
                      <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">ราคาต่อหน่วย</th>
                      <th className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">ส่วนลด</th>
                    </tr>
                  </thead>
                  <tbody>
                    {history && history.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">{index + 1}</td>
                          <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">{new Date(data.updateDate).toLocaleDateString("en")}</td>
                          <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">{data.updateBy}</td>
                          <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">{data.productCode}</td>
                          <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">{data.productName}</td>
                          <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">{productGroup && productGroup?.find(x => x.id === data.productGroup)?.productGroupName}</td>
                          <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">{category && category?.find(x => x.id === data.category)?.categoryName}</td>
                          <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">{data.model}</td>
                          <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">{unit && unit?.find(x => x.id === data.unit)?.unitName}</td>
                          <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">{data.qty}</td>
                          <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">{data.cost}</td>
                          <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">{data.pricePerUnit}</td>
                          <td className="p-3 font-bold text-gray-600 uppercase bg-gray-200 border border-gray-300 lg:table-cell">{data.discount}</td>
                        </tr>
                      )
                    }
                    )}
                  </tbody>
                </table>


              </div>
            </div>
          </form>

        </div>
      </div>
    </>
  );
}
